var _excluded = ["label", "placeholder", "value", "onSubmit", "isSubmitting", "textClass", "required", "disableEdit", "onCancel"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "../elements/button";
import Icon from "../elements/icon.js";
import useFocus from "../../hooks/use-focus";

var TextInputForm = function TextInputForm(_ref) {
  var label = _ref.label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$isSubmitting = _ref.isSubmitting,
      isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
      _ref$textClass = _ref.textClass,
      textClass = _ref$textClass === void 0 ? "" : _ref$textClass,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disableEdit = _ref.disableEdit,
      disableEdit = _ref$disableEdit === void 0 ? false : _ref$disableEdit,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFocus = useFocus(),
      _useFocus2 = _slicedToArray(_useFocus, 2),
      inputRef = _useFocus2[0],
      setInputFocus = _useFocus2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEditMode = _useState2[0],
      setIsEditMode = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      localValue = _useState4[0],
      setLocalValue = _useState4[1];

  var isDisabled = required && !localValue || isSubmitting;
  useEffect(function () {
    if (isEditMode) {
      setInputFocus();
    }
  }, [isEditMode, setInputFocus]);
  useEffect(function () {
    if (disableEdit) {
      setIsEditMode(false);
      setLocalValue(value);
    }
  }, [disableEdit, value]);

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit(localValue);

    if (localValue.trim().length !== 0) {
      setIsEditMode(false);
    }
  };

  var handleCancel = function handleCancel() {
    onCancel();
    setIsEditMode(false);
    setLocalValue(value);
  };

  var enableEditMode = function enableEditMode() {
    setLocalValue(value);
    setIsEditMode(true);
  };

  if (isEditMode || isSubmitting) {
    return /*#__PURE__*/React.createElement("form", {
      className: "et--text-input-form--input-wrapper",
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement("input", _extends({
      ref: inputRef,
      "aria-label": label,
      className: "et--text-input",
      type: "text",
      onChange: function onChange(e) {
        return setLocalValue(e.target.value);
      },
      value: localValue,
      placeholder: placeholder,
      required: required,
      disabled: isSubmitting
    }, rest)), /*#__PURE__*/React.createElement(Button, {
      className: "et--text-input-form--save-button",
      type: "simple",
      onClick: handleSubmit,
      disabled: isDisabled
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      className: "et--text-input-form--cancel-button",
      type: "simple",
      onClick: handleCancel,
      disabled: isSubmitting
    }, "Cancel"));
  }

  return /*#__PURE__*/React.createElement(Button, {
    className: "et--text-input-form--edit-button",
    type: "simple",
    label: "Edit ".concat(label),
    onClick: enableEditMode,
    disabled: disableEdit
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("et--text-input-form--text", textClass)
  }, value || placeholder), /*#__PURE__*/React.createElement(Icon, {
    icon: "edit"
  }));
};

TextInputForm.propTypes = {
  /**
   * aria-label applied to the penci edit icon with "Edit" appended as well as the input field in edit mode
   */
  label: PropTypes.string.isRequired,

  /**
   * placeholder text to display when no value has been set in both read and edit modes
   */
  placeholder: PropTypes.string,

  /**
   * The value to be displayed in both read and edit modes
   */
  value: PropTypes.string,

  /**
   * Callback function typically used to make api call and update value passed in as prop
   */
  onSubmit: PropTypes.func,

  /**
   * Boolean indicating that form is submitting and form should be disabled
   */
  isSubmitting: PropTypes.bool,

  /**
   * Css class applied to the value in read mode
   */
  textClass: PropTypes.string,

  /**
   * Indicates if a value is required or can be blank
   */
  required: PropTypes.bool,

  /**
   * Disable the edit pencil so form cannot be opened
   */
  disableEdit: PropTypes.bool,

  /**
   * Callback function used when process is canceled
   */
  onCancel: PropTypes.func
};
export default TextInputForm;